// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Mob","text":"az_Nob","pulse":"az_Oob","wave":"az_Pob"};